module.exports = __webpack_public_path__ + "img/blog-9.ec3437e7.webp";